var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAo = function SvgAo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12c-.522 0-12 1.565-12 1.565L0 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24 12c0 6.628-5.373 12-12 12S0 18.628 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m10.354 9.544 1.017.738-.388 1.196 1.017-.74 1.017.738-.39-1.195 1.017-.74-1.257.001-.389-1.195-.387 1.196h-1.258Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M15 6.803a5.961 5.961 0 0 0-3-.802v1.565a4.405 4.405 0 0 1 2.217.593 4.44 4.44 0 0 1 1.623 6.058 4.44 4.44 0 0 1-6.058 1.623A4.406 4.406 0 0 1 8.3 14.442l-1.307.863A5.962 5.962 0 0 0 9 17.195 6.007 6.007 0 0 0 17.195 15 6.007 6.007 0 0 0 15 6.803Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M8.539 10.956a1.565 1.565 0 0 0 .622 2.124l5.084 2.778c-.346.632-.162 1.401.47 1.747l1.373.751a1.304 1.304 0 0 0 1.77-.518l.751-1.373-10.07-5.509Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgAo;